import { Translations } from "@/plugins/i18n";

/**
 * Module class that provides different set of grouped routes
 * with their own permissions and translations.
 */
export default class ProductPlan {
	constructor(public translations: Translations) {}
}
